import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils'; // Assuming a utils file exists or will be created for clsx/tailwind-merge

const badgeVariants = cva(
    "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default:
                    "border-transparent bg-blue-500/10 text-blue-400 hover:bg-blue-500/20",
                secondary:
                    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
                destructive:
                    "border-transparent bg-red-500/10 text-red-400 hover:bg-red-500/20",
                success:
                    "border-transparent bg-green-500/10 text-green-400 hover:bg-green-500/20",
                warning:
                    "border-transparent bg-yellow-500/10 text-yellow-400 hover:bg-yellow-500/20",
                purple:
                    "border-transparent bg-purple-500/10 text-purple-400 hover:bg-purple-500/20",
                outline: "text-foreground",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

function Badge({ className, variant, ...props }) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    );
}

export { Badge, badgeVariants };
